import PropTypesOriginal from 'prop-types'

const { shape, string } = PropTypesOriginal
const hiringTeam = shape({
  id: string.isRequired,
  name: string,
  currencyCode: string.isRequired,
  currencySymbol: string.isRequired,
  remunerationPeriod: string,
  region: shape({
    id: string,
    code: string.isRequired,
  }),
})

const children = PropTypesOriginal.oneOfType([PropTypesOriginal.arrayOf(PropTypesOriginal.node), PropTypesOriginal.node])

const PropTypes = { ...PropTypesOriginal, hiringTeam, children }

export default PropTypes
